import { render, staticRenderFns } from "./ImpressaoFormularioObito.vue?vue&type=template&id=1e3cb0a8&scoped=true&"
import script from "./ImpressaoFormularioObito.vue?vue&type=script&lang=js&"
export * from "./ImpressaoFormularioObito.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoFormularioObito.vue?vue&type=style&index=0&id=1e3cb0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3cb0a8",
  null
  
)

export default component.exports